import useTranslation from 'customHooks/translate';

const StatusTag = ({ invoiceStatus }) => {
  const translation = useTranslation();

  const statusClip =
    invoiceStatus === '1'
      ? `${translation.Draft}`
      : invoiceStatus === '2'
      ? `${translation.Paid}`
      : invoiceStatus === '3'
      ? `${translation.Unpaid}`
      : invoiceStatus === '4'
      ? `${translation.Expired}`
      : invoiceStatus === '6'
      ? `${translation.PartiallyPaid}`
      : `${translation.Cancelled}`;

  return (
    <div
      style={{
        backgroundColor:
          invoiceStatus === '1'
            ? '#FFC107'
            : invoiceStatus === '2'
            ? '#4CAF50'
            : invoiceStatus === '3'
            ? '#2196F3'
            : invoiceStatus === '4'
            ? '#F44336'
            : invoiceStatus === '6'
            ? '#00ffaaff'
            : '#9E9E9E',
      }}
      className="justofy-center flex items-center px-[20px] py-[8px] rounded-[20px]"
    >
      <p className="text-[14px] font-medium text-white">{statusClip}</p>
    </div>
  );
};

export default StatusTag;
